var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.634 4a.37.37 0 0 1 .26.098.311.311 0 0 1 .106.238v1.328a.311.311 0 0 1-.106.238.37.37 0 0 1-.26.098H4.366a.37.37 0 0 1-.26-.098A.311.311 0 0 1 4 5.664V4.336c0-.094.035-.173.106-.238A.37.37 0 0 1 4.366 4h15.268zM5.457 7.336h13.086l-1.09 12.367a.32.32 0 0 1-.124.211.376.376 0 0 1-.243.086H6.914a.376.376 0 0 1-.243-.086.32.32 0 0 1-.124-.21L5.457 7.335z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.3b97ddb93231d4f8bb02c258e3630e87.svg";
export { ForwardRef as ReactComponent };